import request from '@/utils/request'

function get(url, query) {
  return request({
    url: url,
    method: 'get',
    params: query
  })
}

function post(url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}


function put(url, data) {
  return request({
    url: url,
    method: 'put',
    data: data
  })
}

function del(url, data) {
  return request({
    url: url,
    method: 'delete',
    data: data
  })
}

export default {
  get, post, put, del
}
